<template>
  <div>
    <basic-container>
      <avue-crud
        :option="option"
        :data="list"
        ref="crud"
        @refresh-change="refreshChange"
      >
        <!-- 自定义搜索框 -->
        <template slot="mySearch">
          <div class="search-contain">
            <div class="search-left">
              <div>
                <!-- 创建时间范围 -->
                <el-date-picker
                  style="
                    width: 250px !important;
                    height: 32px !important;
                    margin-right: 10px;
                  "
                  v-model="searchParams.crateTime"
                  type="daterange"
                  start-placeholder="创建时间范围"
                  range-separator=" "
                  size="small"
                >
                </el-date-picker>
                <!-- 合伙人账号 可清空 -->
                <el-input
                  style="width: 200px !important; margin-right: 10px"
                  clearable
                  v-model="searchParams.partnerPhoneNum"
                  placeholder="合伙人账号"
                >
                </el-input>
                <el-input
                  style="width: 200px !important; margin-right: 10px"
                  clearable
                  v-model="searchParams.userPhoneNum"
                  placeholder="绑定账号"
                >
                </el-input>
                <!-- 设备hid&设备 UID&设备 MAC地址  -->
                <el-input
                  style="width: 220px !important; margin-right: 10px"
                  clearable
                  v-model="searchParams.deviceHid"
                  placeholder="设备hid"
                >
                </el-input>
                <el-input
                  style="width: 220px !important; margin-right: 10px"
                  clearable
                  v-model="searchParams.deviceUid"
                  placeholder="设备UID"
                >
                </el-input>
                <el-input
                  style="width: 220px !important; margin-right: 10px"
                  clearable
                  v-model="searchParams.deviceMac"
                  placeholder="设备MAC地址"
                >
                </el-input>
              </div>
              <div style="display: flex">
                <el-button
                  style="margin-right: 0.5%"
                  type="primary"
                  size="small"
                  @click="search"
                  v-auth="'ENTERPRISE-DISTRIBUTION-BIND-DEVICE-RECORD-SEARCH'"
                  >搜 索</el-button
                >
                <el-button
                  style="margin-right: 0.5%"
                  size="small"
                  @click="handleExport"
                  v-auth="'ENTERPRISE-DISTRIBUTION-BIND-DEVICE-RECORD-EXPORT'"
                  >导 出</el-button
                >
              </div>
            </div>
          </div>
        </template>
        <!-- 自定义表格列 -->
        <!-- <template #mediaName="scope">
          <span style="color: blue;">{{ scope.row.mediaName }}</span>
        </template> -->

        <!-- 自定义表格操作栏 -->
        <!-- <template #menu="{ row }">
          <el-button type="text" size="small" @click="handleEdit(row)"
            >编辑</el-button
          >
        </template> -->
      </avue-crud>
      <ElementPagination
        style="margin-bottom: 20px"
        :current-page="searchParams.current"
        :page-size="searchParams.size"
        :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </basic-container>
    <AddDialog ref="addDialog" :params="params"></AddDialog>
  </div>
</template>

<script>
import ElementPagination from '@/components/ElementPagination'
import Message from '@/components/Message'
import options from './options'
import moment from 'moment'
import { filterObj } from '../utils/index'
import {
  getBindDeviceRecordList,
  exportBindDeviceRecord
} from '@/api/enterpriseDistribution/bindDeviceRecord/index'
export default {
  name: 'WebSassIndex',
  components: {
    ElementPagination
  },
  data() {
    return {
      /** 搜索参数 */
      searchParams: {
        crateTime: '',
        companyName: '',
        size: 10,
        current: 1,
        bindEndTime: '',
        bindStartTime: '',
        partnerPhoneNum: '',
        userPhoneNum: '',
        deviceHid: '',
        deviceUid: '',
        deviceMac: ''
      },
      /** avue里面的表格 */
      list: [
        { id: 1, companyName: 'name', descr: '122' },
        { id: 2, companyName: 'name2', descr: '222' }
      ],
      option: options(this)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    // ^ ^--------------表格内的事件-------------^ ^
    /** 导出的事件 */
    async handleExport() {
      const params = { ...this.searchParams }
      try {
        params.bindStartTime = params.crateTime
          ? moment(params.crateTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
          : ''
        params.bindEndTime = params.crateTime
          ? moment(params.crateTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
          : ''
        // delete params.crateTime
      } catch (error) {
        console.log('时间格式化错误')
        console.log(error)
      }
      const res = await exportBindDeviceRecord(filterObj(params))
      const blob = new Blob([res.data])

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      // 设置下载文件的名称和扩展名
      a.download = decodeURIComponent(
        '绑定设备记录_' + moment().format('YYYY-MM-DD') + '.xlsx'
      )
      document.body.appendChild(a)
      a.click()
      // 释放URL对象
      window.URL.revokeObjectURL(url)
      console.log('导出的响应', res)
    },
    /** 新增的事件 */
    handleAdd() {
      this.$refs.addDialog.show()
    },
    //^ ^--------------分页相关-------------^ ^
    /** 分页查询的事件 */
    async loadList() {
      try {
        this.searchParams.bindStartTime = this.searchParams.crateTime
          ? moment(this.searchParams.crateTime[0]).format('YYYY-MM-DD') +
            ' 00:00:00'
          : ''
        this.searchParams.bindEndTime = this.searchParams.crateTime
          ? moment(this.searchParams.crateTime[1]).format('YYYY-MM-DD') +
            ' 23:59:59'
          : ''
        // delete this.searchParams.crateTime
      } catch (error) {
        console.log('时间格式化错误')
        console.log(error)
      }
      console.log('分页的请求', this.searchParams)
      const params = { ...this.searchParams }
      delete params.crateTime
      const { data } = await getBindDeviceRecordList(filterObj(params))
      console.log('分页的响应', data)
      this.list = data.data.records
      this.searchParams.total = data.data.total
    },
    /** 搜索的事件 */
    search() {
      Message.success('搜索成功')
      console.log('搜索的事件')
      this.loadList()
    },
    /** avue的刷新事件 */
    refreshChange() {
      console.log('avue的刷新事件')
      // this.loadList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val
      Message.success(`每页 ${val} 条`)
      /** 更新数据 */
      // this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val
      Message.success(`当前页 ${val}`)
      /** 更新数据 */
      // this.loadList();
    }
  }
}
</script>

<style lang="scss" scoped>
.search-left {
  width: 100%;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 10px 0px;
  // flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.flex {
  margin-top: 10px;
  padding: 2% 15%;
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap !important;
  background-color: #f7f7f7;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}

.detail-dialog-contain {
  background-color: #f7f7f7;
  padding: 0 10%;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep
  .avue-crud
  .avue-crud__search
  .avue-form
  .avue-form__group
  .avue-form__row
  .el-form-item
  label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__menu {
  position: relative;
  overflow: visible;

  .avue-crud__left {
    position: relative;

    .el-button {
      display: none;
      position: absolute;
      top: -4.5vw;
      left: 72vw;

      span {
        margin: 0;
      }

      .el-icon-download {
        display: none;
      }
    }
  }
}

::v-deep .el-card .is-never-shadow {
  overflow: visible !important;
}
</style>